import React from 'react';
export function AnnouncementBar() {
  return <div className="w-full bg-brand-violet text-white text-center py-1.5 px-4 text-[12px] font-medium z-50 relative" data-id="element-21">
      🔬 Para mujeres con Cándida Recurrente (sin óvulos)
    </div>;
}